//iPhone  - "Mozilla/5.0 (iPhone; CPU iPhone OS 13_2_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.3 Mobile/15E148 Safari/604.1"
//iPad    - "Mozilla/5.0 (iPad; CPU OS 11_0 like Mac OS X) AppleWebKit/604.1.34 (KHTML, like Gecko) Version/11.0 Mobile/15A5341f Safari/604.1"
//iPadPro - "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.3 Safari/605.1.15"
//Samsung - "Mozilla/5.0 (Linux; Android 8.0.0; SM-G955U Build/R16NW) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/87.0.4280.141 Mobile Safari/537.36"
//Android - "Mozilla/5.0 (Linux; Android 10; SM-G960U) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/87.0.4280.141 Mobile Safari/537.36"

export const isMobileDevice = (userAgent: string | null = null): boolean => {
    const ua: string = userAgent || window.navigator.userAgent;

    //iPhone detection
    const isiPhone = /iPhone/i.test(ua);

    // More comprehensive iPad detection, including iPad Pro
    const isiPad =
        /iPad/i.test(ua) ||
        (navigator.maxTouchPoints && navigator.maxTouchPoints > 1 && /Macintosh/i.test(ua));

    // Improved Android detection, ensuring both Android and mobile context
    const isAndroid = /Android/i.test(ua) && /Mobi/i.test(ua);

    // Combined iPhone, iPad, and Android detection
    const isMobile = isiPhone || isiPad || isAndroid;

    // Store the result in local storage for efficiency
    localStorage.setItem("isMobile", isMobile.toString());

    return isMobile;
};
